import React, { useEffect, useState } from 'react';
import { message } from 'antd';

import ChooseTime from './components/chooseTime';
import RowTable from './components/rowTable';
import LineChart from './components/lineChart';
import PieChart from './components/pieChart';
import { gmvIndicator } from '@/services/chartData';
const GMVdata = () => {
  const [rowTableData, setRowTableData] = useState([]);
  const [pieData, setPieData] = useState([]);
  const [lineData, setLineData] = useState([]);
  const [timeRadioValue, setTimeRadioValue] = useState('month');
  const [timeRangeValue, setTimeRangeValue] = useState(['', '']);
  const queryGmvData = () => {
    let requestData = {};
    if (timeRadioValue === 'date') {
      requestData = {
        startDate: timeRangeValue[0],
        endDate: timeRangeValue[1],
      };
    } else {
      requestData = {
        quickQuery: timeRadioValue,
      };
    }
    gmvIndicator({
      requestData: requestData,
    }).then(({ code, msg, data }) => {
      if (code === '00000') {
        setDatas(data);
      } else {
        message.error(msg);
      }
    });
  };
  const setDatas = (data) => {
    setRowTableData([
      {
        title: '总GMV',
        value: data.totalGmv,
        isTailDivider: true,
      },
      {
        title: 'S-B收入',
        value: data.s2bGmv,
        isTailDivider: true,
      },
      {
        title: 'B-C收入',
        value: data.b2cGmv,
        isTailDivider: true,
      },
      {
        title: 'B-B收入',
        value: data.b2bGmv,
        isTailDivider: true,
      },
      {
        title: 'S-C收入',
        value: data.s2cGmv,
        isTailDivider: true,
      },
      {
        title: '退费',
        value: data.refundAmount,
      },
    ]);
    setPieData([
      {
        title: 'S-B收入',
        value: Number(data.s2bGmv),
        isTailDivider: true,
      },
      {
        title: 'B-C收入',
        value: Number(data.b2cGmv),
        isTailDivider: true,
      },
      {
        title: 'B-B收入',
        value: Number(data.b2bGmv),
        isTailDivider: true,
      },
      {
        title: 'S-C收入',
        value: Number(data.s2cGmv),
        isTailDivider: true,
      },
    ]);
    let arr = [];
    arr = arr
      .concat(
        data.s2cGmvTrend.map((i) => {
          return {
            ...i,
            category: 'S-C收入',
          };
        }),
      )
      .concat(
        data.b2cGmvTrend.map((i) => {
          return {
            ...i,
            category: 'B-C收入',
          };
        }),
      )
      .concat(
        data.s2bGmvTrend.map((i) => {
          return {
            ...i,
            category: 'S-B收入',
          };
        }),
      )
      .concat(
        data.b2bGmvTrend.map((i) => {
          return {
            ...i,
            category: 'B-B收入',
          };
        }),
      );
    setLineData(arr);
  };
  useEffect(() => {
    queryGmvData();
  }, [timeRadioValue, timeRangeValue]);
  const handleTimeChange = (type, value) => {
    if (type === 'date' && value) {
      setTimeRangeValue(value);
    }
    setTimeRadioValue(type);
  };
  return (
    <div>
      <ChooseTime
        timeRadioValue={timeRadioValue}
        onTimeChange={handleTimeChange}
      />
      <RowTable rowTableData={rowTableData} title="GMV分类" />
      <PieChart pieData={pieData} />
      <LineChart
        lineData={lineData}
        xField="abscissa"
        yField="ordinate"
        seriesField="category"
      />
    </div>
  );
};

export default GMVdata;
